import type { CopyShape } from "../../intl";

import type { ERRORS_COPY_PT_BR } from "../errors.copy";

export const ERRORS_COPY_EN_US: CopyShape<typeof ERRORS_COPY_PT_BR> = {
  network: "We couldn't reach the server. Check your connection.",
  unauthorized: "Your session expired. Sign in again.",
  forbidden: "You don't have access to this.",
  unexpectedResponse: (endpoint: string) => `Unexpected server response at ${endpoint}.`,
  generic: "Something went wrong. Try again.",
  passwordChangeRequired: "Change your password to continue.",
  legalAcceptanceRequired: "Accept the updated Terms of Use to continue.",
  demoMode: "This is just an example: nothing was saved.",
  phoneNotVerified:
    "Confirm your phone before requesting the proposal — that's how we'll let you know when it's ready.",
};
